"use client";

import { useLayoutEffect } from "react";
import { setOfferModalSuppressed } from "@/util/offerModalGate";

/** Keeps the global offer popup closed on the 404 page. */
export default function SuppressOfferModal() {
  useLayoutEffect(() => {
    setOfferModalSuppressed(true);
    return () => setOfferModalSuppressed(false);
  }, []);

  return null;
}
